import styled, { css } from 'styled-components';

/** Original no-shell layout used by login / signup / onboarding */
export const AuthLayoutWrap = styled.div`
  padding: 0;

  .children {
    width: 100%;
  }
`;

/** Authenticated app shell */
export const StyledLayout = styled.div`
  min-height: 100vh;
  color: var(--white);
  display: flex;
  background: var(--body-bg);
`;

export const MainColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  height: 100vh;
  background: var(--body-bg);
`;

export const MainContent = styled.main`
  flex: 1;
  min-height: 0;

  ${({ $isChatRoute }) =>
    $isChatRoute
      ? css`
          overflow: hidden;
          display: flex;
          flex-direction: column;
        `
      : css`
          overflow-y: auto;
        `}
`;

export const MobileOverlay = styled.button`
  display: none;

  @media (max-width: 1199px) {
    display: block;
    position: fixed;
    inset: 0;
    border: 0;
    padding: 0;
    margin: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 45;
    cursor: pointer;
  }
`;
